/**
 * Created by nmayer on 09.06.16.
 */
define('modules/settings/country/CountryController',['modules/module', 'modules/basemodule/controllers/EntityListController', 'settings'], function (module) {
	'use strict';
	module.controller('CountryController', [
		'$scope',
		'$controller',
		'BASE_TEMPLATES_PATH',
		function ($scope, $controller, BASE_TEMPLATES_PATH) {
			angular.extend(
				this,
				$controller('EntityListController', {
					$scope: $scope,
				})
			);

			$scope.tableOptions.fields = [
				{
					id: 'NAME',
					heading: 'FIELDS.NAME',
					attribute: 'name',
				},
			];
			$scope.formState = 'root.country';

			$scope.init('Country');
		},
	]);
});

